import { setGameStatus, setGamePage } from "../../redux/dispatchers";
import { store } from "../../redux/store";
import {
  GAME_STAGE,
  GAME_STAGE_ACCESS,
  GAME_STAGE_AWAIT,
} from "../../utils/constant";
import { history } from "../../index";

// checkGameStatus checks if the user gameStatus allows them to enter the given screen
// should be called before and when navigating to any pages
export const checkGameStatus = (n) => {
  const { status } = store.getState().gameStates;

  if (!(status in GAME_STAGE_ACCESS)) {
    setGameStatus(0);
    return false;
  }
  return GAME_STAGE_ACCESS[status].includes(n);
};

export const checkGameAwait = (n) => {
  const { status } = store.getState().gameStates;

  if (!(status in GAME_STAGE_AWAIT)) {
    setGameStatus(0);
    return false;
  }
  return GAME_STAGE_AWAIT[status].includes(n);
};

export const checkGameIsAllowRevisit = (n) => {
  return GAME_STAGE_ACCESS[GAME_STAGE_ACCESS.length - 1].includes(n);
};

// checkGamePage  checks if the game page is exactly the input page
export const checkGamePage = (p) => {
  const { page } = store.getState().gameStates;
  return page === p;
};

// navigateGameScreen checks the current user status and navigate to suitable screen
export const navigateGameScreen = (n) => {
  if (n === 0) n = store.getState().gameStates.status;
  // navigate user
  switch (n) {
    case GAME_STAGE.NOTHING:
      setGamePage("", n);
      history.push("/cases");
      break;
    case GAME_STAGE.PRESENTATION:
      setGamePage("", n);
      history.push("/presentation");
      break;
    case GAME_STAGE.HISTORY_TAKING:
      setGamePage("/history", n);
      break;
    case GAME_STAGE.HISTORY_EVALUATION:
      setGamePage("/historyevaluation", n);
      break;
    case GAME_STAGE.HISTORY_SUMMARY:
      setGamePage("/historysummary", n);
      break;
    case GAME_STAGE.DIAGNOSIS_1:
      setGamePage("/diagnosis", n);
      break;
    case GAME_STAGE.EXAMINATION:
      setGamePage("/exam", n);
      break;
    case GAME_STAGE.EXAMINATION_EVALUATION:
      setGamePage("/examevaluation", n);
      break;
    case GAME_STAGE.DIAGNOSIS_2:
      setGamePage("/diagnosis2", n);
      break;
    case GAME_STAGE.INVESTIGATION:
      setGamePage("/investigation", n);
      break;
    case GAME_STAGE.INVESTIGATION_EVALUATION:
      setGamePage("/investigationevaluation", n);
      break;
    case GAME_STAGE.FINAL_DIAGNOSIS:
      setGamePage("/finaldiagnosis", n);
      break;
    case GAME_STAGE.FINAL_DIAGNOSIS_EVALUATION:
      setGamePage("/diagnosisevaluation", n);
      break;
    case GAME_STAGE.MANAGEMENT:
      setGamePage("/management", n);
      break;
    case GAME_STAGE.MANAGEMENT_EVALUATION:
      setGamePage("/managementevaluation", n);
      break;
    case GAME_STAGE.CASE_SUMMARY:
      setGamePage("/casesummary", n);
      break;
    case GAME_STAGE.FINAL_MARKS:
      setGamePage("/finalmarks", n);
      break;
    default:
      break;
  }
};
